// @ts-nocheck - formatter / Table
import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Table, SimpleTextFilter, getVisibleColumns } from '../../common/Table';
import { CommaNumber_NoDecimal } from '../../../util/formatter';
import Loading from '../../common/Loading';
import KwPanel from '../../common/KwPanel';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../hooks/useTableSettings';
import CompanyLink from '../../common/links/CompanyLink';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { loadDisabledTransactionSkus } from '../../../api/keyCodeApi';

export interface ReportedDisabledTransactionSkusListProps {
  id?: string;
  reload?: any;
  handleDownload?: (e: any, item: any) => void;
}

function ReportedDisabledTransactionSkusList({ id, reload, handleDownload }: ReportedDisabledTransactionSkusListProps) {
  const location = useLocation();
  const { t } = useTranslation();
  const allColumns = ['game', 'keyCount', 'companyName'];
  const suffixColumns = ['id'];
  const defaultVisibleColumns = allColumns;
  const [transactions, setTransactions] = useState<any>();
  const params = new URLSearchParams(location.search);
  const {
    tableSettings,
    handleSetTableSettings: setTableSettings,
    filters,
    filterChange,
    isLoading,
  } = useTableSettings(
    'reporteddisabledtransactionskuslist-settings',
    getTableSettingsDefaults({
      defaultSort: 'game',
      defaultVisibleColumns,
    }),
    { id },
    loadDisabledTransactionSkus,
    setTransactions,
    reload,
    t('Failed to load disabled transaction Skus')
  );

  let columnsConfig = [
    {
      Key: 'game',
      Label: t('Game'),
      width: '30%',
      Render: (item: any) => (
        <>
          <NavLink to={`/sku/${item.skuId}`} className="game-title">
            {item.game}
          </NavLink>
          <br />
          <NavLink to={`/sku/${item.skuId}`}>{item.sku}</NavLink>
        </>
      ),
      Filter: {
        Render: (col: any) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
          />
        ),
      },
    },
    {
      Key: 'keyCount',
      Label: t('Key count'),
      width: '20%',
      className: 'text-right num no-wrap',
      Render: (item: any) => CommaNumber_NoDecimal(item.keyCount),
    },
    {
      Key: 'companyName',
      Label: t('Company'),
      width: '30%',
      Render: (item: any) => (
        <CompanyLink
          id={item.companyId}
          name={item.companyName}
          fallbackText={t('--- unknown ---')}
        />
      ),
      Filter: {
        Render: (col: any) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
          />
        ),
      },
    },
    {
      Key: 'id',
      Label: '',
      className: 'text-right',
      Sort: false,
      width: '20%',
      Render: (item: any) => (
        <Button
          className="btn btn-default"
          onClick={(e) => handleDownload?.(e, item)}
          text={t('Download')}
        />
      ),
    },
  ];

  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const suffixColumnsWithConfig = getVisibleColumns(suffixColumns, columnsConfig);
  const columns = getVisibleColumns(visibleColumns, columnsConfig);

  return transactions ? (
    <KwPanel className="mb-4">
      <Table
        columns={columns}
        suffixColumns={suffixColumnsWithConfig}
        allColumns={allColumns}
        rows={transactions.data.map((x: any) => ({ Key: x.skuId, ...x }))}
        totalRowCount={transactions.totalRowCount}
        filteredRowCount={transactions.filteredRowCount}
        tableSettings={tableSettings}
        setTableSettings={setTableSettings}
        isLoading={isLoading}
        filterChange={filterChange}
      />
    </KwPanel>
  ) : (
    <Loading />
  );
}

export default ReportedDisabledTransactionSkusList;
